import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse } from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { MsalService } from '@azure/msal-angular';
import { environment } from 'src/environments/environment';
import { AuthService } from '../services/auth/auth.service';

@Injectable()
export class MsalHttpInterceptor implements HttpInterceptor {
    solrapiUrl = environment.solrApiUrl;
    constructor(
        private msalService: MsalService,
        private auth: AuthService,
    ) {}
    sessionObj: any = { clientId: 0 };
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const isFormData = request.body instanceof FormData;
        if (!isFormData) {
            request = request.clone({ headers: request.headers.set('Content-Type', 'application/json') });
        }
        if (request.url.includes(this.solrapiUrl)) {
            request = request.clone({
                setHeaders: {
                    Authorization: 'Basic dmlld2VyOnA4ZXh1I1E0a2VHVHkkcA==',
                },
            });
        } else if (
            request.url.indexOf('auth/sign-up') === -1 &&
            request.url.indexOf('user/azure-token-login') === -1 &&
            request.url.indexOf('auth/verify-user') === -1 &&
            request.url.indexOf('auth/guest-sign-up') === -1
        ) {
            const authToken = this.auth.getAuthToken();
            if (authToken !== null && authToken !== '') {
                request = request.clone({
                    setHeaders: {
                        Authorization: `Bearer ${authToken}`,
                    },
                });
            }
        }
        return next.handle(request);
    }
}
